import React from 'react';
import { CtaButton } from './ui/CtaButton';
import { SectionLabel } from './ui/SectionLabel';
const PAYMENT_CHIPS = ['💳 Mercado Pago', '💳 Tarjeta', '🏦 Transferencia', '📄 100% PDF'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-ink px-5 py-20 sm:px-8 sm:py-28" data-id="element-76" data-mp="19fql5pl1pfc3">
      <div aria-hidden="true" className="pointer-events-none absolute bottom-0 left-1/2 h-[420px] w-[680px] -translate-x-1/2 rounded-full bg-violeta-700/20 blur-[140px]" data-id="element-77" data-mp="15ckj6u4yuabf" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-78" data-mp="1ed0ma2hsrffr">
        <SectionLabel data-id="element-79" data-mp="1t2omf0e8s81w">El momento es ahora</SectionLabel>
        <h2 className="mt-5 font-display text-4xl font-extrabold leading-[1] text-white sm:text-6xl" data-id="element-80" data-mp="1t2ewtdx402wq">
          El próximo intento
          <span className="mt-2 block text-violeta-400" data-id="element-81" data-mp="223mgapuyuz6r">puede ser diferente.</span>
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-violeta-100/75" data-id="element-82" data-mp="2219yqdt4equ8">
          Cada vez que intentaste sola, terminaste volviendo. No porque no puedas — sino porque nadie
          te dio lo que necesitabas. Esta vez tenés el mapa.
        </p>

        <div className="mt-9" data-id="element-83" data-mp="s57fr6k0xusu">
          <CtaButton href="#planes" data-id="element-84" data-mp="s6ihz1xtmuhu">💜 QUIERO MI MEGAPACK AHORA</CtaButton>
        </div>

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-2.5" data-id="element-85" data-mp="x5v3njcyhviu">
          {PAYMENT_CHIPS.map(chip => <li key={chip} className="rounded-full border border-ink-line bg-ink-soft px-4 py-2 text-xs font-semibold text-violeta-100" data-id="element-86" data-mp="164qbezvnfdo9">
              {chip}
            </li>)}
        </ul>

        <blockquote className="mx-auto mt-14 max-w-lg font-display text-lg font-semibold italic leading-snug text-violeta-200 sm:text-xl" data-id="element-87" data-mp="1fvkz88ojmlbt">
          “La próxima vez que dudes de vos misma, recordá que llegaste hasta acá.”
        </blockquote>
      </div>
    </section>;
}